import {
  normalizeLogin,
  normalizeSavedSearch,
  normalizeSession,
  normalizeToken,
} from 'api/normalize';
// eslint-disable-next-line no-restricted-imports
import {
  MemberModel,
  MemberResponse,
  MembershipModel,
  MembershipResponse,
} from 'types';
import { normalizePaidAccount } from './account';
import genericNormalizer from './generic';
import { normalizeMessagesDismissed } from './messages-dismissed';

export const normalizeMember = genericNormalizer<MemberResponse, MemberModel>(
  ({ fallback, from, has }) => ({
    avatars: has('avatarHash', (avatarHash) => {
      return avatarHash
        ? ['30', '50', '170', 'original'].reduce(
            (avatars: { [key: string]: string }, size) => {
              avatars[size] = `${__AVATAR_ROOT__}/${avatarHash}/${size}.png`;

              return avatars;
            },
            {},
          )
        : null;
    }),
    // NOTE: It's possible that we'll receive an update for our own model
    // over the board channel.  On the board channel we only see the public
    // version of the member model, which may have avatarSource set to null
    avatarSource: (
      { avatarSource },
      existing,
    ): Exclude<MemberResponse['avatarSource'], null> => {
      return avatarSource || existing;
    },
    bio: from('bio'),
    channels: from('channels'),
    confirmed: from('confirmed'),
    email: from('email'),
    enterprises: from('enterprises'),
    id: from('id'),
    idBoards: from('idBoards'),
    idEnterprisesAdmin: from('idEnterprisesAdmin'),
    idOrganizations: from('idOrganizations'),
    idPremOrgsAdmin: fallback(from('idPremOrgsAdmin'), []),
    initials: from('initials'),
    logins: has('logins', (logins) =>
      logins.map((login) => normalizeLogin(login)),
    ),
    loginTypes: from('loginTypes'),
    marketingOptIn: has('marketingOptIn', (marketingOptIn) => {
      if (!('date' in marketingOptIn)) {
        return {};
      }

      const { date, optedIn } = marketingOptIn;

      return {
        date: new Date(date),
        optedIn,
      };
    }),
    memberType: from('memberType'),
    messagesDismissed: has(
      'messagesDismissed',
      (messagesDismissed) =>
        messagesDismissed
          ? messagesDismissed.map((message) =>
              normalizeMessagesDismissed(message),
            )
          : null,
    ),
    name: from('fullName'),
    paidAccount: has('paidAccount', normalizePaidAccount),
    prefs: from('prefs'),
    products: from('products'),
    savedSearches: has('savedSearches', (savedSearches) =>
      savedSearches.map((search) => normalizeSavedSearch(search)),
    ),
    sessions: has('sessions', (sessions) =>
      sessions.map((session) => normalizeSession(session)),
    ),
    tokens: has('tokens', (tokens) =>
      tokens.map((token) => normalizeToken(token)),
    ),
    username: from('username'),
  }),
);

export const normalizeMembership = genericNormalizer<
  MembershipResponse,
  MembershipModel
>(({ from }) => ({
  id: from('id'),
  deactivated: from('deactivated'),
  idMember: from('idMember'),
  type: from('memberType'),
  unconfirmed: from('unconfirmed'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/member.ts